import { render, staticRenderFns } from "./TechnicalSupport.vue?vue&type=template&id=f834fdd2&scoped=true&"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js&"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSupport.vue?vue&type=style&index=0&id=f834fdd2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f834fdd2",
  null
  
)

export default component.exports